import { images } from '../constants';

const speakers = [
    {
        id: 1,
        image: images.speaker1,
        name: 'John Carter',
        title: 'Tech Engineer',
        biography: "John Carter is a skilled tech engineer specializing in software development and system architecture. With a robust background in various programming languages and frameworks, he is committed to building innovative solutions that enhance productivity and efficiency in the tech industry. John's dedication to continuous learning and improvement makes him a valuable asset to any project.",
        contacts: {
            phone: '555-123-4567',
            email: 'john.carter@example.com',
            website: 'www.johncartertech.com',
            company: 'Innovate Tech Solutions',
            experience: '8+ Years in Tech Engineering',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            'Tech Innovator Award (2021)',
            'Best Software Engineer Award (2020)',
            'Excellence in Engineering Award (2019)',
        ],
        skills: [
            { id: 1, title: 'Software Development', progress: 92 },
            { id: 2, title: 'System Architecture', progress: 88 },
            { id: 3, title: 'Project Management', progress: 85 },
        ],
        sessions: [
            {
                id: 1,
                title: 'AI in Autonomous Vehicles',
                image: 'images/Schedule/Sessions/Session-1.jpg',
                date: 'Fri, 01 Nov',
                time: '10:00 AM - 1:00 PM',
                venue: 'Main Auditorium',
                link: '../../pages/Schedule/Schedule-Single.html',
            },
            {
                id: 2,
                title: 'AI and Augmented Reality',
                image: 'images/Schedule/Sessions/Session-7.jpg',
                date: 'Sat, 02 Nov',
                time: '2:15 PM - 3:45 PM',
                venue: 'Hall No 2',
                link: '../../pages/Schedule/Schedule-Single.html',
            }
        ]
    },
    {
        id: 2, 
        image: images.speaker2,
        name: "Dr. Sophia Lee",
        title: "AI Researcher",
        biography: "Dr. Sophia Lee is a leading AI researcher with expertise in machine learning, neural networks, and natural language processing. She has contributed to numerous groundbreaking studies in artificial intelligence and is passionate about developing ethical AI solutions that benefit society. Her work focuses on advancing AI capabilities while ensuring responsible and transparent AI implementation.",
        contacts: {
            phone: '555-123-4567',
            email: 'john.carter@example.com',
            website: 'www.johncartertech.com',
            company: 'Innovate Tech Solutions',
            experience: '8+ Years in Tech Engineering',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "AI Research Excellence Award (2022)",
            "Top Innovator in Machine Learning (2021)",
            "Best Paper Award in AI Ethics (2020)"
        ],
        skills: [
            { id: 1, title: "Machine Learning", progress: 95 },
            { id: 2, title: "Neural Networks", progress: 90 },
            { id: 3, title: "Natural Language Processing", progress: 88 }
        ]
    },
    {
        id: 3, 
        image: images.speaker3,
        name: "Michael Zhang",
        title: "Cybersecurity Expert",
        biography: "Michael Zhang is a highly skilled cybersecurity expert with a deep understanding of network security, ethical hacking, and data protection. With years of experience in securing digital infrastructures, he has helped organizations safeguard sensitive information and defend against cyber threats. His expertise in risk assessment and threat mitigation makes him a leader in the cybersecurity field.",
        contacts: {
            phone: '555-123-4567',
            email: 'john.carter@example.com',
            website: 'www.johncartertech.com',
            company: 'Innovate Tech Solutions',
            experience: '8+ Years in Tech Engineering',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Cybersecurity Excellence Award (2022)",
            "Top Ethical Hacker Recognition (2021)",
            "Best Cyber Defense Strategy Award (2020)"
        ],
        skills: [
            { id: 1, title: "Network Security", progress: 94 },
            { id: 2, title: "Ethical Hacking", progress: 92 },
            { id: 3, title: "Data Protection", progress: 89 }
        ]
    },
    {
        id: 4, 
        image: images.speaker4,
        name: "Dr. Sarah Evans",
        title: "Smart City Planner",
        biography: "Dr. Sarah Evans is a visionary smart city planner dedicated to developing sustainable and technologically advanced urban environments. With expertise in urban planning, IoT integration, and green infrastructure, she collaborates with governments and organizations to create smart solutions that enhance city living. Her work focuses on energy efficiency, smart mobility, and digital transformation in urban areas.",
        contacts: {
            phone: '555-123-4567',
            email: 'john.carter@example.com',
            website: 'www.johncartertech.com',
            company: 'Innovate Tech Solutions',
            experience: '8+ Years in Tech Engineering',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Smart City Innovator Award (2022)",
            "Best Urban Planning Strategy (2021)",
            "Top Sustainable Development Leader (2020)"
        ],
        skills: [
            { id: 1, title: "Urban Planning", progress: 95 },
            { id: 2, title: "IoT Integration", progress: 90 },
            { id: 3, title: "Sustainable Development", progress: 88 }
        ]
    },
    {
        id: 5, 
        image: images.speaker5,
        name: "Prof. David Kim",
        title: "EdTech Innovator",
        biography: "Prof. David Kim is a pioneering EdTech innovator dedicated to transforming education through technology. With expertise in digital learning, AI-driven education, and curriculum development, he collaborates with institutions to enhance learning experiences. His work focuses on adaptive learning, online education platforms, and integrating AI into modern teaching methods.",
        contacts: {
            phone: '555-123-4567',
            email: 'john.carter@example.com',
            website: 'www.johncartertech.com',
            company: 'Innovate Tech Solutions',
            experience: '8+ Years in Tech Engineering',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "EdTech Innovator of the Year (2022)",
            "Best AI Learning Platform Award (2021)",
            "Excellence in Digital Education (2020)"
        ],
        skills: [
            { id: 1, title: "Digital Learning", progress: 94 },
            { id: 2, title: "AI in Education", progress: 91 },
            { id: 3, title: "Curriculum Development", progress: 89 }
        ]
    },
    {
        id: 6, 
        image: images.speaker6,
        name: "Dr. Angela Parker",
        title: "Robotics Engineer",
        biography: "Dr. Angela Parker is a leading robotics engineer specializing in autonomous systems and AI-driven robotics. With extensive experience in industrial automation, humanoid robotics, and machine learning integration, she is dedicated to advancing robotics technology for real-world applications. Her research focuses on enhancing robotic efficiency, safety, and human-robot collaboration.",
        contacts: {
            phone: '555-123-4567',
            email: 'john.carter@example.com',
            website: 'www.johncartertech.com',
            company: 'Innovate Tech Solutions',
            experience: '8+ Years in Tech Engineering',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Top Robotics Innovator Award (2023)",
            "Breakthrough in AI Robotics Award (2021)",
            "Best Industrial Automation Project (2020)"
        ],
        skills: [
            { id: 1, title: "Autonomous Systems", progress: 95 },
            { id: 2, title: "AI-Driven Robotics", progress: 92 },
            { id: 3, title: "Machine Learning Integration", progress: 90 }
        ]
    },
    {
        id: 7, 
        image: images.speaker7,
        name: "Joe Root",
        title: "Legal Tech Expert",
        biography: "Joe Root is a pioneering legal tech expert specializing in AI-driven legal solutions and digital transformation in the legal industry. With a deep understanding of legal frameworks and technology integration, he is committed to developing innovative tools that streamline legal processes, enhance compliance, and improve access to justice. His expertise bridges the gap between law and technology, making legal services more efficient and accessible.",
        contacts: {
            phone: '555-123-4567',
            email: 'john.carter@example.com',
            website: 'www.johncartertech.com',
            company: 'Innovate Tech Solutions',
            experience: '8+ Years in Tech Engineering',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "Legal Tech Innovator Award (2022)",
            "Top AI Legal Solutions Developer (2021)",
            "Best Digital Transformation Leader (2020)"
        ],
        skills: [
            { id: 1, title: "AI-Driven Legal Solutions", progress: 93 },
            { id: 2, title: "Legal Compliance Automation", progress: 90 },
            { id: 3, title: "Blockchain for Legal Tech", progress: 88 }
        ]
    },
    {
        id: 8, 
        image: images.speaker8,
        name: "Dr. Jane Smith",
        title: "AI Financial Analyst",
        biography: "Dr. Jane Smith is a leading AI financial analyst specializing in predictive analytics, algorithmic trading, and risk assessment. With a strong background in artificial intelligence and financial modeling, she develops cutting-edge solutions that optimize investment strategies and enhance decision-making in the financial sector. Her expertise in machine learning and quantitative analysis makes her a key innovator in fintech.",
        contacts: {
            phone: '555-123-4567',
            email: 'john.carter@example.com',
            website: 'www.johncartertech.com',
            company: 'Innovate Tech Solutions',
            experience: '8+ Years in Tech Engineering',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        achievements: [
            "AI in Finance Excellence Award (2023)",
            "Top Fintech Innovator (2022)",
            "Best Algorithmic Trading Research (2021)"
        ],
        skills: [
            { id: 1, title: "Predictive Analytics", progress: 95 },
            { id: 2, title: "Algorithmic Trading", progress: 92 },
            { id: 3, title: "Risk Assessment", progress: 89 }
        ]
    }
];

export default speakers;